var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAustraliaFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#dc1f26;}.cls-4{fill:#00008b;}.cls-5{fill:#fff;}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:red;}.cls-8{clip-path:url(#clip-path-3);}.cls-9{clip-path:url(#clip-path-4);}.cls-10{clip-path:url(#clip-path-7);}.cls-11{clip-path:url(#clip-path-8);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 3,
    width: 1500,
    height: 1000
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 3,
    width: 834.19,
    height: 455.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 421.18,
    y: 134.68,
    width: 471.16,
    height: 402.29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -32.42,
    y: -34.75,
    width: 459.3,
    height: 512.37
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 434.01,
    y: -23.59,
    width: 405.27,
    height: 560.57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -23.95,
    y: -34.75,
    width: 466.62,
    height: 512.37
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag-of-Australia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -78.43,
    y: -97,
    width: 1656.86,
    height: 1200
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "-78.43 -48.5 -78.43 316.47 -78.43 324.55 -78.43 681.45 -78.43 689.53 -78.43 1054.5 1578.43 1054.5 1578.43 689.53 1578.43 681.45 1578.43 324.55 1578.43 316.47 1578.43 -48.5 -78.43 -48.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "427.26 579.39 452.97 644.81 519.92 624.21 485.03 685.19 542.8 724.92 473.59 735.54 478.68 805.68 427.26 757.95 375.84 805.68 380.94 735.54 311.72 724.92 369.49 685.19 334.61 624.21 401.55 644.81 427.26 579.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1020.81 342.49 1030.65 367.54 1056.28 359.65 1042.93 383 1065.05 398.21 1038.55 402.28 1040.5 429.13 1020.81 410.86 1001.12 429.13 1003.07 402.28 976.57 398.21 998.69 383 985.33 359.65 1010.96 367.54 1020.81 342.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1223.26 126.73 1233.11 151.77 1258.74 143.89 1245.38 167.24 1267.5 182.45 1241 186.51 1242.95 213.37 1223.26 195.1 1203.57 213.37 1205.52 186.51 1179.02 182.45 1201.14 167.24 1187.79 143.89 1213.42 151.77 1223.26 126.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1398.78 299.17 1408.62 324.21 1434.26 316.33 1420.9 339.68 1443.02 354.89 1416.52 358.96 1418.47 385.81 1398.78 367.54 1379.09 385.81 1381.04 358.96 1354.54 354.89 1376.66 339.68 1363.3 316.33 1388.94 324.21 1398.78 299.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1223.26 663.82 1233.11 688.87 1258.74 680.98 1245.38 704.33 1267.5 719.54 1241 723.61 1242.95 750.46 1223.26 732.19 1203.57 750.46 1205.52 723.61 1179.02 719.54 1201.14 704.33 1187.79 680.98 1213.42 688.87 1223.26 663.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "826.18 505.57 -88.18 6.3 -48.45 -79.33 865.91 419.95 826.18 505.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "833.63 489.52 -80.73 -9.75 -69.13 -34.75 845.23 464.52 833.63 489.52"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-48.45 -79.33 865.91 419.95 826.18 505.57 -88.18 6.3 -48.45 -79.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-55.89 -63.28 858.47 435.99 846.87 460.99 -67.49 -38.28 -55.89 -63.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "826.18 505.57 -88.18 6.3 -48.45 -79.33 865.91 419.95 826.18 505.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "833.63 489.52 -80.73 -9.75 -69.13 -34.75 845.23 464.52 833.63 489.52"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-48.45 -79.33 865.91 419.95 826.18 505.57 -88.18 6.3 -48.45 -79.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-55.89 -63.28 858.47 435.99 846.87 460.99 -67.49 -38.28 -55.89 -63.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "826.18 505.57 -88.18 6.3 -48.45 -79.33 865.91 419.95 826.18 505.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "833.63 489.52 -80.73 -9.75 -69.13 -34.75 845.23 464.52 833.63 489.52"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "893.82 -79.33 -20.54 419.95 19.2 505.57 933.55 6.3 893.82 -79.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "901.27 -63.28 -13.09 435.99 -1.49 460.99 912.87 -38.28 901.27 -63.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "19.2 505.57 933.55 6.3 893.82 -79.33 -20.54 419.95 19.2 505.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "11.75 489.52 926.11 -9.75 914.51 -34.75 0.15 464.52 11.75 489.52"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 154.2,
    width: 842.36,
    height: 151.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 349.27,
    y: 1.58,
    width: 139.82,
    height: 456.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 375.61,
    y: 1.58,
    width: 87.14,
    height: 456.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 182.78,
    width: 842.36,
    height: 94.52
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaFlag);
export default __webpack_public_path__ + "static/media/australia-flag.15448ff7214726c276c64f50d7509212.svg";
export { ForwardRef as ReactComponent };